module.exports = "1.7.3"


/*****************
 ** WEBPACK FOOTER
 ** ./~/fluxxor/version.js
 ** module id = 98
 ** module chunks = 0
 **/